class ChapterDuesProfileController {
    constructor($http, $window, $timeout) {
        'ngInject';
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.data = [];
        this.spinner = true;

        this.httpError = false;
    }

    $onInit() {
        this.$timeout(() => {
            this.$http({
                url: '/api/chapterleader/getchapterdues',
                method: 'GET'
            }).then((response) => {
                this.data = response.data;
                this.spinner = false;
            }, (response) => {
                this.spinner = false;
                this.httpError = true;
            });
        }, 1000);
    }
}

export default ChapterDuesProfileController;



// WEBPACK FOOTER //
// ./src/app/angular/chapter-dues-profile/chapter-dues-profile.controller.js